<template>
    <span @click="onclick">
        <v-autocomplete
            required
            prepend-icon="domain"

            :loading="loading"

            item-text="name" item-value="id"

            :items="list"

            :value="client.id"
            @input="changeClient"
            :search-input.sync="search"
            ></v-autocomplete>
    </span>
</template>
<script>
import {mapState} from 'vuex'; //Vuex getter map

export default {
        name: "client-toggle",
        props: {
            apiUrl:{type:String,default:'/clients/list'},
        },
        data() {
            return {
                loading:false,
                search:'',
                list:[ this.$store.state.client ],
            }
        },
        mounted() {
        },
        computed: {
            ...mapState(['client'])
        },
        watch: {
            search (s) {s && this.fetchData(s)}
        },
        methods: {
            onclick(){this.fetchData(this.search);},
            fetchData(s){
                this.loading=true;
                axios.get(this.apiUrl,{params:{s}}).then(r=>{
                    this.loading=false;
                    this.list = r.data;
                    if(this.list.length===1)
                        this.val=this.list[0];
                }).catch(e=>{
                    this.loading=false;
                    console.log(e);
                });
            },
            changeClient(id){
                axios.post(`/clients/${id}/select`).then(r=>{
                    store.commit('setClient',r.data);
                }).catch(e=>{
                    console.error(e);

                })
            }
        },

        components: {},
        filters: {}
    }
</script>
